<template>
    <div>
    <section class="home-container" id="home">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-md-6">
                    <h3 class="display-4 home-main-text pt-4">
                        Our Services
                    </h3>
                    <h2>We offer full spectrum services to help clients work better.</h2>

                    <br>
                    <span>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has
                        been the industry's standard dummy text ever since the 1500s.</span>
                </div>

                <div class="col-lg-6 col-md-6">

                <div class="">
                        <img v-bind:src="'../imgs/img_service.png'" class="dashboard-image img-fluid m-2" alt="">
                </div>
                   
                   <div >
                 </div>
                   
                </div>
            </div>
        </div>
    </section>
    
<section>
    <div class="container">
        <h2 class="text-center" style="font-weight: bold;">Services</h2>

  <div class="box-area">
    <div class="single-feature-box">
      <div class="img-area features-img-one">
        <i class="fas fa-laptop-house  text-6xl"></i>
        </div>
      <div class="img-text">
        <span class="header-text" ><strong>Remote</strong></span>

        <p style="margin-bottom: 40px;">Offsite Support is the assistance provided to you at your office via the support centre, telephone, email or chat. We believe that these offsite options will help resolve your concerns in the fastest and most efficient manner. 
        </p>
      </div>
    </div>
    <div class="single-feature-box">
      <div class="img-area features-img-two">
        <i class="fas fa-shoe-prints  text-6xl"></i>

      </div>
      <div class="img-text">
        <span class="header-text"><strong>Onsite</strong></span>
        <p>You might require a visit of our engineer at your office to assist you with your Tally software. We call this Onsite Service.
        Partial list of onsite support offerings are Installation, Accounting, Implementation, Training, Data migration, Data Troubleshooting and many more.

         </p>
      </div>
    </div>
    <div class="single-feature-box">
      <div class="img-area features-img-three">
        <i class="fas fa-briefcase  text-6xl"></i>

      </div>
      <div class="img-text">
        <span class="header-text"><strong>Implementation</strong></span>
        <p>
            Expertise gleaned from our 2 decades of providing technology solutions to businesses in emerging economies. The tremendous flexibility & adaptability of TallyPrime simplifies the implementation and makes it an easy to start and configure on an incremental basis.
        </p>
      </div>
    </div>
  </div>
<br>
  <div class="box-area">
    <div class="single-feature-box">
      <div class="img-area features-img-four">
        <i class="fas fa-code-branch  text-6xl"></i>

      </div>
      <div class="img-text">
        <span class="header-text"><strong>Training</strong></span>
        <p>Our Corporate training program contains various modules which can be picked &amp; chosen from so that it satisfies your organizational training needs. </p>
      </div>
    </div>
    <div class="single-feature-box">
      <div class="img-area features-img-five">
        <i class="fas fa-sync  text-6xl"></i>

      </div>
      <div class="img-text">
        <span class="header-text"><strong>Synchronisation</strong></span>
        <p>TallyPrime gives you the flexibility to manage your data across multiple locations be it your regional office or factory locations to the Head Office in just one click.</p>
      </div>
    </div>
    <div class="single-feature-box">
      <div class="img-area features-img-six">
        <i class="fas fa-random text-6xl"></i>

      </div>
      <div class="img-text">
        <span class="header-text"><strong>Data Migration</strong></span>
        <p>Migrating to TallyPrime from any prior version of Tally is simple - these tools are either built into the product itself or available as migration tools that are installed along with the product.</p>
      </div>
    </div>
  </div>
  </div>
</section>

<br>
<br>

<section>
    <div class="container">
    <h2 class="text-center" style="font-weight: bold; color:#3069B3;">New to Tally? Get Yourself Started</h2>
    
    <div class="grid grid-cols-3 gap-2 mb-5 mt-5 text-center ">
            <div class="mt-4">
               <iframe width="100%" height="100%" src="https://www.youtube.com/embed/Ow6NXj3PzBo" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>

            <div class="mt-4">
                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/leyl5w8GAmo" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            <div class="mt-4">
                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/1MHWbYNDirc" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
        </div>        
    </div>
</section>
    </div>
</template>


<script type="application/javascript">
import { Head, Link } from '@inertiajs/inertia-vue3';
import JetNavLink from '@/Jetstream/NavLink.vue'

// import $ from 'jquery';

    export default {
       components:{
         JetNavLink,
        },
        props: {
            canLogin: Boolean,
            canRegister: Boolean,

            // prod_id:string,
        },
         data() {
        return {
            canRegister:true,
            // url: '', 
        }
    },
      mounted() {
          const typedTextSpan = document.querySelector(".typed-text");
    const cursorSpan = document.querySelector(".cursor");
   console.log(cursorSpan)
    const textArray = ["hard", "fun", "a journey", "LIFE"];
    const typingDelay = 200;
    const erasingDelay = 100;
    const newTextDelay = 2000; // Delay between current and next text
    let textArrayIndex = 0;
    let charIndex = 0;

    function type() {
        if (charIndex < textArray[textArrayIndex].length) {
            if (!cursorSpan.classList.contains("typing")) cursorSpan.classList.add("typing");
            typedTextSpan.textContent += textArray[textArrayIndex].charAt(charIndex);
            charIndex++;
            setTimeout(type, typingDelay);
        } else {
            cursorSpan.classList.remove("typing");
            setTimeout(erase, newTextDelay);
        }
    }

    function erase() {
        if (charIndex > 0) {
            if (!cursorSpan.classList.contains("typing")) cursorSpan.classList.add("typing");
            typedTextSpan.textContent = textArray[textArrayIndex].substring(0, charIndex - 1);
            charIndex--;
            setTimeout(erase, erasingDelay);
        } else {
            cursorSpan.classList.remove("typing");
            textArrayIndex++;
            if (textArrayIndex >= textArray.length) textArrayIndex = 0;
            setTimeout(type, typingDelay + 1100);
        }
    }

    document.addEventListener("DOMContentLoaded", function() { // On DOM Load initiate the effect
        if (textArray.length) setTimeout(type, newTextDelay + 250);
    });
    
    }
    }
  
    
</script>

<style scoped>
 a:hover{
        text-decoration: none;
    }
.img_size{
    height: auto;
    width: 156px;
}
:root {
        --blue: #0068CA;
        --white: #ffffff;
        --primary: #82C5FF;
        --secondary: #FDC031;
        --black: #333333;
        --input_grey: #d7d7d7;
        --hint_grey: #bfbfbf;
        --pink: #FF4B69;
    }

    * {
        outline: none;
    }

    /*Scroll - START*/
    /* width */
    ::-webkit-scrollbar {
        width: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #888;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    
.box-area {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.single-feature-box {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 300px;
  height: auto;
  border-radius: 4px;
  background-color: #fff;
  margin: 20px;
  padding: 20px;
  transition: .3s;
  text-align: center;
}

.img-area {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 120px;
  height: 120px;
  border: 6px solid #60A7FF;
  border-radius: 50%;
  margin-bottom: 10px;
  padding: 1px;
  background-repeat: no-repeat;

}

.header-text {
  font-size: 24px;
  font-weight: 500;
  line-height: 29px;

}

.img-text {

  padding-top: 20px;
}

.img-text p{
  font-size: 15px;
  font-weight: 400;
  line-height: 30px;
  margin-top: 15px;
}

.single-feature-box:hover {
  background: #60A7FF;

}

.single-feature-box:hover > .img-area{
     border: 6px solid #333333;
     transition: 0.5s;

}

        .support-card{
            border: 2px solid #DEE1E6;
            border-radius: 10px;
            transition: 2s;
        }
        .support-font-awesome{
            font-size: 8vh;
            color: #60A7FF;
        }
        .support-phone-number{
            font-weight: bold;
            /*display: none;*/
            transition: 2s;
            font-size: 16px;
        }
        .support-card:hover > .support-phone-number{
            display: block;
            transition: 2s;
          }
          .support-card:hover{
            border: 2px solid #BABABA;
            border-radius: 10px;
            transition: 0.1s;
          }

</style>

